import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import RegionController from "../../components/pageManager/RegionController";

const RegionControllerPage = ({geoIds}) => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <RegionController geoIds={geoIds}/>
                </div>
            </div>
        </div>
    );
};

export default RegionControllerPage;
